import type { DirectorySharedParams } from '@centivo/provider-directory-components'

type ProfileKind = 'doctor' | 'institution'

interface ProfileNavParams {
  fetchParams?: DirectorySharedParams
  distance?: number
  placeId?: string
}

export interface ParsedProfileSearch {
  fetchParams: DirectorySharedParams
  distance: number | undefined
  placeId: string | undefined
}

export function buildProfileLocation(
  kind: ProfileKind,
  id: string,
  params: ProfileNavParams
): { pathname: string; search: string } {
  const pathname =
    kind === 'doctor' ? `/doctorDetails/${id}` : `/institutionDetails/${id}`

  const qs = new URLSearchParams()

  if (params.fetchParams && Object.keys(params.fetchParams).length > 0) {
    qs.set('fp', JSON.stringify(params.fetchParams))
  }
  if (params.distance !== undefined) qs.set('distance', String(params.distance))
  if (params.placeId) qs.set('placeId', params.placeId)

  const search = qs.toString() ? `?${qs.toString()}` : ''
  return { pathname, search }
}

export function parseProfileSearch(search: string): ParsedProfileSearch {
  const qs = new URLSearchParams(
    search.startsWith('?') ? search.slice(1) : search
  )

  let fetchParams: DirectorySharedParams = {}
  const fpRaw = qs.get('fp')
  if (fpRaw) {
    try {
      fetchParams = JSON.parse(fpRaw) as DirectorySharedParams
    } catch {
      fetchParams = {}
    }
  }

  const distanceRaw = qs.get('distance')
  const distance =
    distanceRaw !== null && distanceRaw !== ''
      ? parseFloat(distanceRaw)
      : undefined

  const placeIdRaw = qs.get('placeId')
  const placeId =
    placeIdRaw !== null && placeIdRaw !== '' ? placeIdRaw : undefined

  return { fetchParams, distance, placeId }
}
